import useAccountSettings from '@/composables/logged-in-user-account/account-settings';
import useUsers from '@/composables/user/users';
import { computed } from 'vue';
import { productPlan } from 'shared/constants.json';

export default function useUserLimit() {
  const { accountSettings } = useAccountSettings();
  const { users } = useUsers();

  const nonDemoUserCount = computed(() => users.value.filter((u) => !u.isDemo).length);

  const userLimitValue = computed(() => accountSettings.value?.userLimit);

  const isTrial = computed(() => accountSettings.value?.planId === productPlan.trial);

  const wouldExceedUserLimit = (additionalUsers) => isTrial.value
    && userLimitValue.value !== undefined
    && nonDemoUserCount.value + additionalUsers > userLimitValue.value;

  const userLimitReached = computed(() => wouldExceedUserLimit(1));

  return {
    nonDemoUserCount,
    userLimitValue,
    userLimitReached,
    isTrial,
    wouldExceedUserLimit,
  };
}
